import Handsontable from "handsontable";
import { string } from "prop-types";
import svg_icon_path from "../../static/media/SVGSpriteIcon.svg";
import "./../../Pages/Users/Create_User/CreateUser.css"
var defaultGroupCount = 10000;
export function firstNameRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.BaseRenderer.apply(this, arguments);
    let rowData = cellProperties.instance.getSourceDataAtRow(
        cellProperties.instance.toPhysicalRow(row)
    );
    cellProperties.className = cellProperties.className.replace(' wkusergriddisabled', '');
    if (!rowData) {
        return;
    }

    else if (rowData.clientType == "Entity") {
        cellProperties.readOnly = true;
        cellProperties.className = cellProperties.className + " wkusergriddisabled";
        cellProperties.placeholder = "";
        value = "";
    }
    else if (rowData.clientType == "Individual") {
        cellProperties.readOnly = false;
        cellProperties.className = cellProperties.className.replace('wkusergriddisabled', '');
        cellProperties.placeholder = rowData.clientId == 0 ? "Enter First Name" : "";
    }
    else if (this.isAddClientClicked && (rowData.clientId == null || rowData.clientId == 0)) {
        cellProperties.placeholder = "Enter First Name";
    }
    td.innerHTML = value;
    Handsontable.cellTypes.text.renderer(
        instance,
        td,
        row,
        col,
        prop,
        value,
        cellProperties
    );
}

export function middleNameRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.BaseRenderer.apply(this, arguments);
    let rowData = cellProperties.instance.getSourceDataAtRow(
        cellProperties.instance.toPhysicalRow(row)
    );
    cellProperties.className = cellProperties.className.replace(' wkusergriddisabled', '');
    if (!rowData) {
        return;
    }
    else if (rowData.clientType == "Entity") {
        cellProperties.readOnly = true;
        cellProperties.className = cellProperties.className + " wkusergriddisabled";
        cellProperties.placeholder = "";
        value = "";
    }
    else if (rowData.clientType == "Individual") {
        cellProperties.readOnly = false;
        cellProperties.className = cellProperties.className.replace('wkusergriddisabled', '');
        cellProperties.placeholder = rowData.clientId == 0 ? "Enter Middle Name" : "";
    }
    else if (this.isAddClientClicked && (rowData.clientId == null || rowData.clientId == 0)) {
        cellProperties.placeholder = "Enter Middle Name";
    }
    td.innerHTML = value;
    Handsontable.cellTypes.text.renderer(
        instance,
        td,
        row,
        col,
        prop,
        value,
        cellProperties
    );
}
export function iconRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);

    let rowData = cellProperties.instance.getSourceDataAtRow(
        cellProperties.instance.toPhysicalRow(row)
    );

    if (!rowData) {
        return;
    }
    else if (rowData.active == "Inactive") {
        cellProperties.readOnly = true;
        cellProperties.editor = false;
        cellProperties.className = "wkusergriddisabled"

    }
    if (rowData.cparesponsibleId == 0 || rowData.cparesponsibleId == null || rowData.cparesponsibleId == "undefined") {
        cellProperties.className = cellProperties.className + ' color-wk-primary-red';
        td.innerHTML = "<svg class='svg_icon xcm-icon-user size-20 color-wk-primary-red' > <title> Click here to add staffing.</title><use xlink:Href =" + svg_icon_path + "#xcm-icon-user></use ></svg>"
    }
    else {
        td.innerHTML = "<svg class='svg_icon xcm-icon-user size-20' > <title> Click here to add staffing.</title><use xlink:Href =" + svg_icon_path + "#xcm-icon-user></use ></svg>"
    }
}
export function lastNameRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.BaseRenderer.apply(this, arguments);
    let rowData = cellProperties.instance.getSourceDataAtRow(
        cellProperties.instance.toPhysicalRow(row)
    );
    if (!rowData) {
        return;
    }
    //below code needed in next phase of development
    //else if (rowData.isLinked == "Y") { 
    //    td.innerHTML = "<a href='/'>" +
    //        value +
    //        "  </a>";
    //}
    else if (this.isAddClientClicked && (rowData.clientId == null || rowData.clientId == 0)) {
        cellProperties.placeholder = "Enter Last/Entity Name";
    }
    else {
        td.innerHTML = value;
    }
    Handsontable.cellTypes.text.renderer(
        instance,
        td,
        row,
        col,
        prop,
        value,
        cellProperties
    );
}

export function setPlaceholder(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.BaseRenderer.apply(this, arguments);
    let rowData = cellProperties.instance.getSourceDataAtRow(
        cellProperties.instance.toPhysicalRow(row)
    );
    if (!rowData) {
        return;
    }
    else if (this.isAddClientClicked && (rowData.clientId == null || rowData.clientId == 0)) {
        if (prop === "accountNumber")
            cellProperties.placeholder = "Enter Number";
        if (prop === "emailId")
            cellProperties.placeholder = "Enter Email Id";
        if (prop === "phoneNumber")
            cellProperties.placeholder = "Enter Phone Number";
        if (prop === "fiscalYear")
            cellProperties.placeholder = "Enter Fiscal Year End (mm/dd)";
    }
    Handsontable.cellTypes.text.renderer(
        instance,
        td,
        row,
        col,
        prop,
        value,
        cellProperties
    );
}

export function customDropdownRendererPlaceholder(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.BaseRenderer.apply(this, arguments);
    let rowData = cellProperties.instance.getSourceDataAtRow(
        cellProperties.instance.toPhysicalRow(row)
    );

    if (!rowData) {
        return;
    }
    if (prop === "groupName") {
        if (this.props.groupNames?.length > defaultGroupCount) {
            cellProperties.readOnly = true;
            cellProperties.className = cellProperties.className + " wkusergriddisabled";
            td.title =
                "You have too many groups to choose from. In order to organize your clients or entities into groups, please use 'Bulk Edit' operation on this page or 'Manage Groups' functionality available in the Utilities section.";
        } else {
            cellProperties.readOnly = false;
            cellProperties.className = cellProperties.className.replace('wkusergriddisabled', '');
        }
    }

    if (prop === "staffName") {
        cellProperties.placeholder = "--Select--";
        if (instance.getDataAtCell(0, 2) == null || instance.getDataAtCell(0, 2) == 'Required Role Selection' || instance.getDataAtCell(0, 2) == '')
            instance.getCellMetaAtRow(0)[2].className = instance.getCellMetaAtRow(0)[2].className + ' cell-border-warningbox';
        else
            instance.getCellMetaAtRow(0)[2].className = instance.getCellMetaAtRow(0)[2].className.replaceAll(' cell-border-warningbox', '');
    }
    else if (this.isAddClientClicked && (rowData.clientId == null || rowData.clientId == 0)) {
        if (prop === "clientType" || prop === "generationType" || prop === "branchName" || prop === "groupName" || prop === "primaryTaskCode")
            cellProperties.placeholder = "--Select--";
    }

    if (prop === "generationType") {
        if (rowData.clientType == "Entity") {
            cellProperties.readOnly = true;
            cellProperties.className = cellProperties.className + " wkusergriddisabled";
            cellProperties.placeholder = "";
            value = "";
        }
        else if (rowData.clientType == "Individual") {
            cellProperties.readOnly = false;
            cellProperties.className = cellProperties.className.replace('wkusergriddisabled', '');
            cellProperties.placeholder = rowData.clientId == 0 ? "--Select--" : "";
        }
    }
    if (prop === "primaryTaskCode" && value != null && value != "") {
        let regExp = /\(([^)]+)\)/;
        value = regExp.exec(value) != null ? value.toString().substring(value.lastIndexOf('(')).replace(/[()]/g, '').trim() : value;
    }

    let optionsList = cellProperties.selectOptions.data;
    if (
        typeof optionsList === "undefined" ||
        typeof optionsList.length === "undefined" ||
        !optionsList.length ||
        !value
    ) {
        Handsontable.cellTypes.text.renderer(
            instance,
            td,
            row,
            col,
            prop,
            value,
            cellProperties
        );
        return td;
    }
    var values =
        typeof value == "string"
            ? value.split("|").map(i => (typeof i == "string" ? i.trim() : i))
            : value;

    value = values.filter(v => v !== "").join("; ");
    Handsontable.cellTypes.text.renderer(
        instance,
        td,
        row,
        col,
        prop,
        value,
        cellProperties
    );

    return td;
}

export function portalIconRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);

    let rowData = cellProperties.instance.getSourceDataAtRow(
        cellProperties.instance.toPhysicalRow(row)
    );
    if (!rowData) {
        return;
    }
    if (rowData.axcessClientGuid == null) {
        cellProperties.readOnly = true;
        cellProperties.editor = false;
        cellProperties.className = "wkusergriddisabled"
    }
    td.innerHTML = "<svg class='svg_icon xcm-icon-portal size-20' > <title> Click here to navigate to client profile.</title><use xlink:Href =" + svg_icon_path + "#xcm-icon-portal></use ></svg>"
}